/** Label sizing and the Text fade threshold. */

/** Constant SCREEN pixels. Never scaled by zoom: that is the Obsidian look. */
export const LABEL_PX = 11;
export const LABEL_Z_MIN = 0.5;
export const LABEL_Z_SPAN = 12;
/** Fade spans about half a zoom step: visible, but not sluggish. */
export const LABEL_FADE_BAND = 1.6;
/** Below this alpha there is nothing to see, so skip the draw entirely. */
export const LABEL_ALPHA_FLOOR = 0.04;
/** Past this many labels a graph is an unreadable text smear. */
export const MAX_LABELS = 200;
export const LABEL_MAX_CHARS = 22;

/**
 * The threshold is GEOMETRIC in zoom, not linear. Zoom is perceptually
 * logarithmic, so a linear threshold slider feels dead across most of its
 * travel: textFade 0 -> labels from z 0.5, -1 -> 0.04 (always), 1 -> 6.
 * The default hides labels at overview zoom, which is the Obsidian look: a
 * zoomed-out vault is a field of dots, and titles fade in as you dive.
 */
export function labelOpacity(z: number, textFade: number): number {
  const zNone = LABEL_Z_MIN * Math.pow(LABEL_Z_SPAN, textFade);
  const zFull = zNone * LABEL_FADE_BAND;
  const t = (z - zNone) / (zFull - zNone);
  if (t <= 0) return 0;
  if (t >= 1) return 1;
  // smoothstep, so there is no linear-ramp banding as it fades
  return t * t * (3 - 2 * t);
}

export function truncateLabel(text: string): string {
  const t = text.trim() || "Untitled";
  return t.length <= LABEL_MAX_CHARS ? t : `${t.slice(0, LABEL_MAX_CHARS - 1)}…`;
}
